import { createContext, useContext } from "react";

const NO_CHROME = Object.freeze({ header: false, bottomBar: false });

export const PwaChromeContext = createContext(NO_CHROME);

export const usePwaChrome = () => useContext(PwaChromeContext);
